import { render } from "./ShiftSelectionItem.vue?vue&type=template&id=755c67be&scoped=true"
import script from "./ShiftSelectionItem.vue?vue&type=script&lang=js"
export * from "./ShiftSelectionItem.vue?vue&type=script&lang=js"

import "./ShiftSelectionItem.vue?vue&type=style&index=0&id=755c67be&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755c67be"]])

export default __exports__